<template>
  <div id="">
    <!-- <span class="basisInformation">班级管理</span>
    <el-divider></el-divider> -->
    <el-row :gutter="12">
      <el-col :span="24" class="col-header">
        <el-card shadow="never"> 班级管理</el-card>
      </el-col>
    </el-row>
    <!-- 头部功能区域 -->
    <el-form :inline="true" class="demo-form-inline" size="small">
      <el-form-item>
        <el-input placeholder="请输入学生姓名" style="width: 120px" v-model.trim="studentObj.name" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item v-if="type == 8 ? false : true">
        <el-input placeholder="请输入学籍号" v-model.trim="studentObj.rosterNo"></el-input>
      </el-form-item>
      <el-form-item v-else>
        <el-input placeholder="请输入学员编号" maxlength="20" v-model.trim="studentObj.rosterNo"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select placeholder="请选择状态" v-model="studentObj.active" @change="ApiStudentListPag" style="width: 120px">
          <el-option label="全部状态" value=""></el-option>
          <el-option label="已激活" value="1"></el-option>
          <el-option label="未激活" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchLists">搜 索</el-button>
      </el-form-item>
      <el-form-item>
        <add-student :gradeList="gradeList" :nationList="nationList" :relationList="relationList"
          @updateList="searchList" />
      </el-form-item>

      <el-form-item v-if="type == 8 ? false : true">
        <el-button size="small" type="primary" @click="RemoveParent">解除家长绑定</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="ApiExportStudentList">一键导出</el-button>
      </el-form-item>
    </el-form>
    <!-- 头部功能区域 -->
    <!-- 表格区域 -->
    <el-table :row-style="{ height: '48px' }" :header-cell-style="{ background: '#f5f5f5', height: '48px' }"
      style="width: 100%" border stripe ref="studentTable" :data="studentTableList"
      @selection-change="handleSelectionChange">
      <el-table-column v-if="type == 8 ? false : true" type="selection" align="center" :selectable="CheckSelecttable" />
      <el-table-column v-if="type == 8 ? false : true" label="班级" align="center" width="100">
        <template slot-scope="scope">
          {{
            scope.row.gradeClasses.gradeName + scope.row.gradeClasses.className
          }}
        </template>
      </el-table-column>
      <el-table-column v-else label="班级" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.gradeClasses.className }}
        </template>
      </el-table-column>
      <el-table-column v-if="type == 8 ? false : true" label="学籍号" prop="student.rosterNo" width="220" align="center">
      </el-table-column>
      <el-table-column v-else label="学员编号" prop="student.rosterNo" width="220" align="center">
      </el-table-column>
      <el-table-column align="center" prop="student.name" label="学生姓名">
      </el-table-column>
      <el-table-column align="center" label="家长姓名">
        <template slot-scope="scope">
          <span v-if="scope.row.parentList && scope.row.parentList.length">
            <span style="margin-left: 4px" v-for="item in scope.row.parentList"
              :key="item.id + item.mobile">{{ item.name }}</span>
          </span>
          <add-parent v-else :relationList="relationList" :studentId="scope.row.student.id" @updateList="searchList" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="家长电话">
        <template slot-scope="scope">
          <span v-if="scope.row.parentList && scope.row.parentList.length">
            <span>{{ scope.row.parentList[0].mobile }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span>{{ scope.row.student.active ? '已激活' : '未激活' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" header-align="center">
        <template slot-scope="scope">
          <!-- <el-button type="primary" size="small">编辑</el-button> -->

          <el-button type="text" size="small" class="text_btn"
            @click="ApiResetPass('student', scope.row)">重置学生密码</el-button>
          <el-button type="text" size="small" v-if="scope.row.parentList && scope.row.parentList.length"
            @click="ApiResetPass('parent', scope.row)">重置家长密码</el-button>

          <update-student :gradeList="gradeList" :nationList="nationList" :relationList="relationList"
            @updateList="searchList" :classes="scope.row.gradeClasses" :studentObj="scope.row.student"
            :parentList="scope.row.parentList" />
          <el-button type="text" size="small" class="left_btn delete_btn"
            @click="DeleteStudentHandle(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <el-pagination background layout="total,prev,pager,next,sizes" :page-size="studentObj.pageSize"
      :page-sizes="[10, 20, 50, 100]" :current-page="studentObj.curPage" @current-change="currentChange"
      :total="studentObj.totalCount" @size-change="handleSizeChange"></el-pagination>
  </div>
</template>
<script>
import addParent from './addParent'
import addStudent from './addStudent.vue'
import updateStudent from './updateStudent'
import datajson from './nation.json'
import {
  studentList,
  resetPassword,
  gradeClassList,
  studentUnbindParent,
  dexportStudent,
  deletdStudent
} from '@/api/home'

export default {
  components: {
    addParent,
    addStudent,
    updateStudent
  },

  data() {
    return {
      schoolId: localStorage.getItem('schoolIds'),
      studentObj: {
        curPage: 1,
        pageSize: 20,
        gradeId: localStorage.getItem('gradeId'), // 年级id
        classesId: localStorage.getItem('classId'), // 班级id
        name: '', // 学生姓名
        rosterNo: '', // 学籍号
        totalCount: 0, //  studentTableList 总条数
        active: ''
      },
      studentTableList: [], // 表格数据列表
      gradeList: [], //年级列表
      classesList: [], //班级列表
      nationList: datajson.nationList, // 民族列表
      relationList: datajson.relationList, // 关系列表
      dialogVisible: false, //导出学生
      dialogAction: '',
      exportStudentObj: {
        schoolId: localStorage.getItem('schoolIds'),
        gradeId: localStorage.getItem('gradeId'), // 年级
        classesId: localStorage.getItem('classId'), // 班级
        studentTemplateType: 1 //类型
      },
      type: '',
      typeTime: ''
    }
  },
  created() {
    this.ApiStudentListPag()
    this.ApigradeGradelist()
    this.type = localStorage.getItem('type')

    //  this.typeTime = setInterval(() => {
    //   this.type = localStorage.getItem('type')
    //   this.selectType()
    // }, 500);
  },
  methods: {
    // 删除学生
    DeleteStudentHandle(obj) {
      this.$confirm(
        `您确定要删除 <span style="color:#409EFF;margin:0 10px;">${obj.student.name}</span>学生么?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          deletdStudent(obj.student.id).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.ApiStudentListPag()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // selectType(){
    //   if (this.type !== null) {
    //     clearInterval(this.typeTime)
    //   }
    // },
    // 选中 学生
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 禁用选择框
    CheckSelecttable(row, index) {
      return !!row.parentList.length
    },

    // 获取学生列表
    ApiStudentListPag() {
      studentList({
        schoolId: this.schoolId,
        ...this.studentObj
      }).then(res => {
        this.studentTableList = res.data.data.dataList
        this.studentObj.totalCount = res.data.data.totalCount
      })
    },

    // 分页页码变化
    currentChange(e) {
      this.studentObj.curPage = e
      // 调用查询学生列表
      this.ApiStudentListPag()
    },

    handleSizeChange(val) {
      this.studentObj.curPage = 1
      this.studentObj.pageSize = val
      this.ApiStudentListPag()
    },

    // 搜索和重置功能
    searchList() {
      // this.studentObj.curPage = 1
      this.ApiStudentListPag()
    },
    searchLists() {
      this.studentObj.curPage = 1
      this.ApiStudentListPag()
    },

    //重置密码
    ApiResetPass(roleType, obj) {
      this.$confirm(
        `您确定要重置<span style="color:#409EFF;margin:0 10px;">${obj.student
          .name + ' '}${roleType == 'parent' ? '家长' : '学生'
        }</span>的密码么?重置后的密码是000000`,
        '重置密码',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          let data = {
            roleType,
            userId: roleType == 'parent' ? obj.parentList[0].id : obj.student.id
          }
          resetPassword({ ...data }).then(() => {
            this.$message({
              type: 'success',
              message: '重置成功'
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消重置'
          })
        })
    },

    // 获取年级列表
    ApigradeGradelist() {
      gradeClassList({
        schoolId: this.schoolId
      }).then(res => {
        this.gradeList = res.data.data
        this.classesList = this.gradeList[0].classesList
      })
    },

    // 解除家长绑定
    async RemoveParent() {
      const confirResult = await this.$confirm('您确定要解除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirResult !== 'confirm') {
        return this.$message.info('已取消！！')
      }
      let ids = []
      if (!this.multipleSelection.length) {
        return this.$message.error('请选择需要解除家长绑定的学生')
      }
      this.multipleSelection.map(k => {
        ids.push(k.student.id)
      })
      ids = ids.join(',')
      studentUnbindParent({
        ids: ids
      }).then(() => {
        this.$message({
          type: 'success',
          message: '解除成功'
        })
        this.multipleSelection = []
        this.$refs.studentTable.clearSelection()
        this.searchList()
      })
    },

    async ApiExportStudentList() {
      if (this.studentTableList.length != 0) {
        let classNames =
          this.studentTableList[0].gradeClasses.gradeName +
          this.studentTableList[0].gradeClasses.className +
          '学生列表'
        console.log('classNames', classNames)
        const res = await dexportStudent(this.exportStudentObj, classNames)
        return false
      }
      this.$message.error('暂无数据')
    }
  }
}
</script>
<style scoped>
.basisInformation {
  font-size: 16px;
  font-weight: 700;
  margin-top: 10px;
}

.el-divider {
  margin-top: 18px;
  margin-bottom: 18px;
}
.el-table__body .el-button + .el-button {
  margin-left: 20px;
}
.text_btn {
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/school/components/components/teacherclass.vue